module.exports = __webpack_public_path__ + "3ccae42ddc9d360dbbcaa0650ed6a1a7.png";